"use strict";
(self["webpackChunkubco"] = self["webpackChunkubco"] || []).push([[914],{

/***/ 5538:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var scripts_vue_components_Accordion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3383);
/* harmony import */ var scripts_vue_components_AccordionItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6088);




window.PSTheme.Vue.faq = new (vue__WEBPACK_IMPORTED_MODULE_2___default())({
  name: "faq",
  components: {
    Accordion: scripts_vue_components_Accordion__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    AccordionItem: scripts_vue_components_AccordionItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
  },

  data() {
    return {
      mounted: false,
      allQuestions: "",
      allTabs: "",
      searchKeyword: "",
      noResults: false,
      searchFormActive: false
    };
  },

  computed: {// filteredList() {
    //   return this.postList.filter((post) => {
    //     return post.title.toLowerCase().includes(this.search.toLowerCase());
    //   });
    // },
  },
  methods: {
    changeToTab(goToTab) {
      let allQuestions = this.allQuestions;
      let allTabs = this.allTabs; // UPDATE QUESTIONS LIST

      allQuestions.forEach(function (question) {
        question.classList.remove("active");

        if (question.classList.contains(goToTab)) {
          question.classList.add("active");
        }
      }); // UPDATE TABS

      allTabs.forEach(function (tab) {
        tab.classList.remove("active");

        if (tab.classList.contains(goToTab)) {
          tab.classList.add("active");
        }
      });
    },

    searchFaq() {// TODO: Add search filter. REFERENCE: Natural Pet Food.
    },

    /*
      * openQuestionFromUrl() function was create to solve this problem:
       * The client wants to send users to F.A.Q. page and lead them straight to a specific question.
       * To solve this, a HASH value is passed on the URL to identify the question to open.
       * Also, a page number is stored to the navigation <a> item (data-page)
      * to find the page where the question is.
       * So after the component is Mounted this function will trigger a click() function
      * to the question page AND click() function to open the question.
    */
    openQuestionFromUrl(hash) {
      let pageNumber = document.querySelector(hash).dataset.page;
      let pageToGo = document.querySelector(`#page-${pageNumber}`);
      let questionToOpen = document.querySelector(hash).nextElementSibling.firstChild;

      if (pageToGo && questionToOpen) {
        pageToGo.click();
        questionToOpen.click();
      }
    }

  },

  mounted() {
    this.mounted = true;
    this.allQuestions = document.querySelectorAll(".tabs-item-wrap");
    this.allTabs = document.querySelectorAll(".tab-nav-item");
    this.openQuestionFromUrl(window.location.hash);
  }

}).$mount(".page-faq");

/***/ }),

/***/ 3383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Accordion; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Accordion.vue?vue&type=template&id=146ac3b1&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['accordion', _vm.additionalClasses !== '' ? _vm.additionalClasses : '']},[_vm._t("default")],2)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Accordion.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var Accordionvue_type_script_lang_js_ = ({
  props: {
    additionalClasses: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      Accordion: {
        count: 0,
        active: null
      }
    };
  },

  provide() {
    return {
      Accordion: this.Accordion
    };
  }

});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Accordion.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Accordionvue_type_script_lang_js_ = (Accordionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Accordion.vue



;


/* normalize component */

var component = (0,componentNormalizer/* default */.Z)(
  components_Accordionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Accordion = (component.exports);

/***/ }),

/***/ 6088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AccordionItem; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/AccordionItem.vue?vue&type=template&id=2ba8e6e7&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accourdion__item-wrap"},[_c('li',{staticClass:"accordion__item",on:{"click":_vm.open}},[_c('div',{class:[ 'accordion__item-question h6', { 'active': _vm.visible } ]},[_vm._t("accordion-question"),_vm._v(" "),_c('span',{staticClass:"icon-toggle",class:{ 'active': _vm.visible }})],2)]),_vm._v(" "),_c('transition',{attrs:{"name":"accordion"},on:{"enter":_vm.start,"after-enter":_vm.end,"before-leave":_vm.start,"after-leave":_vm.end}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"accordion__item-answer"},[_vm._t("accordion-answer")],2)])],1)}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/AccordionItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var AccordionItemvue_type_script_lang_js_ = ({
  inject: ['Accordion'],

  data() {
    return {
      index: null
    };
  },

  computed: {
    visible() {
      return this.index == this.Accordion.active;
    }

  },

  created() {
    this.index = this.Accordion.count++; // Load wit first open
    // if (this.index == 0) {
    //   this.Accordion.active = this.index
    // }
  },

  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
    },

    start(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    end(el) {
      el.style.height = '';
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/AccordionItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AccordionItemvue_type_script_lang_js_ = (AccordionItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/AccordionItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_AccordionItemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccordionItem = (component.exports);

/***/ }),

/***/ 1900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346], function() { return __webpack_exec__(5538); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);